module.exports = __webpack_public_path__ + "static/media/2025_Cowi.843c1de8.png";